/**
 * @generated SignedSource<<9c2211ddfcb8a928430a87227e317ad4>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type DeliveryMethod =
  | 'BRILLIANT'
  | 'CHECKBOOK_I_O_FIRST_CLASS'
  | 'CHECKBOOK_I_O_TWO_DAY'
  | 'FEDEX_2_DAY'
  | 'FEDEX_3_DAY'
  | 'FEDEX_OVERNIGHT'
  | 'UNKNOWN'
  | 'USPS_FIRST_CLASS'
  | 'USPS_PRIORITY'
  | 'USPS_PRIORITY_EXPRESS'
  | 'USPS_REGISTERED'
  | 'USPS_UNTRACKED'
  | '%future added value';
export type ShippingAddressPageShipmentOptionsQuery$variables = Record<PropertyKey, never>;
export type ShippingAddressPageShipmentOptionsQuery$data = {
  readonly shipmentOptions: ReadonlyArray<{
    readonly canRequireSignature: boolean;
    readonly carrier: string;
    readonly deliveryMethod: DeliveryMethod;
    readonly description: string;
    readonly eta: number;
    readonly etaEnd: number | null;
    readonly feeAmountMicro: number;
    readonly id: string;
    readonly logoUrl: string;
    readonly name: string;
  }>;
};
export type ShippingAddressPageShipmentOptionsQuery = {
  response: ShippingAddressPageShipmentOptionsQuery$data;
  variables: ShippingAddressPageShipmentOptionsQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
    {
      alias: null,
      args: null,
      concreteType: 'ShipmentOption',
      kind: 'LinkedField',
      name: 'shipmentOptions',
      plural: true,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'id',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'name',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'description',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'carrier',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'deliveryMethod',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'logoUrl',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'feeAmountMicro',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'canRequireSignature',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'eta',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'etaEnd',
          storageKey: null,
        },
      ],
      storageKey: null,
    },
  ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'ShippingAddressPageShipmentOptionsQuery',
      selections: v0 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'ShippingAddressPageShipmentOptionsQuery',
      selections: v0 /*: any*/,
    },
    params: {
      cacheID: 'de2a5c93144c36d61c9143f40aa4a5b8',
      id: null,
      metadata: {},
      name: 'ShippingAddressPageShipmentOptionsQuery',
      operationKind: 'query',
      text: 'query ShippingAddressPageShipmentOptionsQuery {\n  shipmentOptions {\n    id\n    name\n    description\n    carrier\n    deliveryMethod\n    logoUrl\n    feeAmountMicro\n    canRequireSignature\n    eta\n    etaEnd\n  }\n}\n',
    },
  };
})();

(node as any).hash = '44f206a4e115875ac49f410423947e09';

export default node;
